<div class="dialog-header w-100 d-flex justify-content-end">
    <button
        mat-icon-button
        color="warn"
        (click)="closePad()"
        tabindex="-1">
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="dialog-content m-0 p-0">
    <canvas
        #signaturePad
        class="signature-pad"
        (touchstart)="isSignatureEmpty = false"
        (click)="isSignatureEmpty = false"></canvas>
</mat-dialog-content>
<mat-dialog-actions
    [align]="'center'"
    class="d-flex flex-row flex-wrap gap-3">
    <button
        mat-flat-button
        color="accent"
        class="flex-grow-1"
        (click)="clearPad()">
        <mat-icon fontSet="material-symbols-outlined">backspace</mat-icon>
        {{ 'ECMR.signature.clear' | translate }}
    </button>
    <button
        mat-flat-button
        color="primary"
        class="flex-grow-1 ms-0"
        (click)="savePad()"
        [disabled]="isNotSigned()">
        <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
        {{ 'ECMR.common.save' | translate }}
    </button>
</mat-dialog-actions>
